// extracted by mini-css-extract-plugin
export default {"cardListBlockText":"CardListBlock_cardListBlockText__X44Ay"};